import React from 'react';
import styled from 'styled-components';
import StarRating from '../StarRating';
import { ChameleonLink } from '../Link';
import { colors, spaces, typography } from '../../lib/styles';

export interface Props {
    avgRating: number;
    totalRatings: number;
    ctaUrl?: string;
}

const StyledAggregatedStarRating = styled.div`
    display: flex;
`;

const Item = styled.span`
    & + & {
        margin-left: ${spaces.space4}px;
    }

    font-size: ${typography.fontSizes.links.subtle}px;
`;

export default function AggregatedStarRating({ avgRating, totalRatings, ctaUrl }: Props) {
    return (
        <StyledAggregatedStarRating>
            <Item aria-label="average rating" data-testid="aggregated-star-rating-rating">
                {Math.round(avgRating * 10) / 10}
            </Item>
            <Item>
                <StarRating rating={avgRating} variations={['small']} color={colors.grey800} />
            </Item>
            <Item aria-label="total ratings" style={{ color: colors.grey700 }}>
                {ctaUrl ? (
                    <ChameleonLink href={ctaUrl} role="link" size="subtle">
                        ({totalRatings})
                    </ChameleonLink>
                ) : (
                    `(${totalRatings})`
                )}
            </Item>
        </StyledAggregatedStarRating>
    );
}
